import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import DashboardWidget from './DashboardWidget';
import BottomDropZone from './BottomDropZone';

/**
 * DroppableColumn component
 * Represents a droppable column in the dashboard grid
 */
export default function DroppableColumn({ id, widgets, editMode, isEmpty, staggerOffset = 0 }) {
    const { setNodeRef, isOver } = useDroppable({
        id: id,
        disabled: false // Always allow dropping
    });

    let columnClasses = 'min-h-[400px] rounded-lg transition-all duration-200 p-2 relative';
    
    if (isOver && editMode) {
        columnClasses += ' ring-2 ring-pink-500 dark:ring-pink-500 bg-pink-50/20 dark:bg-pink-500/10';
    } else if (isEmpty) {
        columnClasses += ' border-2 border-dashed border-zinc-300 dark:border-zinc-700';
    }

    return (
        <div ref={setNodeRef} className={columnClasses}>
            <SortableContext
                items={widgets.map(w => w.widgetInstanceKey)}
                strategy={verticalListSortingStrategy}
            >
                <div className="space-y-4">
                    {/* Empty state messages */}
                    {isEmpty && !editMode && (
                        <div className="flex items-center justify-center h-[200px] text-zinc-400 dark:text-zinc-400">
                            This column is empty
                        </div>
                    )}

                    {isEmpty && editMode && (
                        <div className="flex items-center justify-center h-[200px] text-zinc-400 dark:text-zinc-400">
                            Drag widgets here
                        </div>
                    )}

                    {/* Render widgets */}
                    {widgets.map((widget, idx) => (
                        <DashboardWidget
                            key={widget.widgetInstanceKey}
                            widget={widget}
                            editMode={editMode}
                            staggerIndex={staggerOffset + idx}
                        />
                    ))}

                    {/* Bottom drop zone - only show if column has widgets */}
                    {!isEmpty && <BottomDropZone id={`${id}-bottom`} />}
                </div>
            </SortableContext>
        </div>
    );
}
